import React, { useState } from "react";
import { DataCard, CardContainer } from "components/styled/dataCard/DataCard";
import DataCardRow from "components/styled/dataCard/DataCardRow";
import FirmaDigitalIcon from "assets/icons/ic_signature.svg";
import getPhoneFormat from "libs/getPhoneFormat";
import { FirmaSolicitud } from "api/types/originacion/services/analisisSolicitudTypes";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";
import { styled } from "@material-ui/core/styles";
import CertificadoAuditoriaModal from "./CertificadoAuditoriaModal";
import SolicitudFirmadaModal from "./SolicitudFirmadaModal";

const FirmaDigitalCard: React.FC<{
  telefono?: FirmaSolicitud["telefono"];
  solicitudId?: number;
  isLoading?: boolean;
}> = ({ telefono, solicitudId, isLoading = false }) => {
  const [isCertificadoModalOpen, setIsCertificadoModalOpen] = useState(false);
  const [isSolicitudModalOpen, setIsSolicitudModalOpen] = useState(false);

  const renderTelefonos = () => {
    if (!telefono) return "-";
    return getPhoneFormat(telefono as any);
  };

  return (
    <CardContainer>
      <DataCard
        title="FIRMA DIGITAL"
        icon={<img src={FirmaDigitalIcon} alt="contact-icon" />}
      >
        <DataCardRow
          label="Celular"
          isLoading={isLoading}
          value={renderTelefonos()}
          selectable
        />
        {solicitudId && (
          <>
            <DataCardRow
              label="Certificado de Auditoría"
              isLoading={isLoading}
              selectable
              value={
                <Typography>
                  <StyledLink onClick={() => setIsCertificadoModalOpen(true)}>
                    Ver certificado
                  </StyledLink>
                </Typography>
              }
            />
            <DataCardRow
              label="Solicitud firmada"
              isLoading={isLoading}
              selectable
              value={
                <Typography>
                  <StyledLink onClick={() => setIsSolicitudModalOpen(true)}>
                    Ver solicitud
                  </StyledLink>
                </Typography>
              }
            />
          </>
        )}
      </DataCard>

      <CertificadoAuditoriaModal
        solicitudId={solicitudId}
        open={isCertificadoModalOpen}
        onClose={() => setIsCertificadoModalOpen(false)}
      />
      <SolicitudFirmadaModal
        solicitudId={solicitudId}
        open={isSolicitudModalOpen}
        onClose={() => setIsSolicitudModalOpen(false)}
      />
    </CardContainer>
  );
};

export default FirmaDigitalCard;

const StyledLink = styled(Link)(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  fontWeight: 800,
  "&:focus, &:visited, &:link, &:active": {
    textDecoration: "none",
  },
  textDecoration: "underline",
  "&:hover": {
    cursor: "pointer",
  },
}));
